module.exports = __webpack_public_path__ + "media/assets/dashboard/organize-cc421d898305aaa2df0576ad64de0d36.png";